export default "__VITE_ASSET__BUHvZLW3__"